import type { PoisStoreContent } from '../types';
import type { LayoutLoad } from './$types';
import { writable } from 'svelte/store';
import { createSearchPOIsFromAddressStore, createSearchPoisStore } from '../loadPois';

export const load = (async () => {
	// Create a root store for the pois
	// So every page can access the same pois store
	// This improves the performance of the app as the datasheet page can reuse the pois store already loaded by the map page
	const poisStore = writable<PoisStoreContent | null>(null);

	const searchPOIStore = createSearchPoisStore();
	const searchPOIFromAddressStore = createSearchPOIsFromAddressStore();

	return {
		poisStore,
		searchPOIStore,
		searchPOIFromAddressStore,
	};
}) satisfies LayoutLoad;
